"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@tiendanube/icons");
var __1 = require("..");
var utils_1 = require("./utils");
function Item(_a) {
    var title = _a.title, name = _a.name, description = _a.description, labels = _a.labels, skeleton = _a.skeleton, hideBorder = _a.hideBorder, onChange = _a.onChange, blockLeft = _a.blockLeft, icon = _a.icon, iconAppearance = _a.iconAppearance, disabled = _a.disabled;
    var mainClass = (0, classnames_1.default)("nimbus--interactive-list-item", {
        "nimbus--interactive-list-item__borderBottom": hideBorder,
        "nimbus--interactive-list-disabled": disabled,
    });
    var handleChange = function () {
        if (!disabled)
            onChange({ name: name, checked: true });
    };
    return (React.createElement("div", { role: "listitem", className: mainClass },
        React.createElement("button", { type: "button", id: name, onClick: handleChange, className: "nimbus--interactive-list-item__button" },
            (0, utils_1.renderBlockLeft)(blockLeft),
            React.createElement("div", { className: "nimbus--interactive-list-item__content" },
                React.createElement("div", { className: "nimbus--interactive-list-item__title" },
                    (0, utils_1.renderIcon)(icon, iconAppearance),
                    skeleton ? React.createElement(__1.Text.Skeleton, null) : React.createElement(__1.Text, null, title),
                    !skeleton && React.createElement(icons_1.ChevronRightIcon, null)),
                (0, utils_1.renderBelow)(description, labels, skeleton)))));
}
exports.default = Item;
//# sourceMappingURL=InteractiveListPriv.ActionItem.js.map